import React from "react";
import {observer} from 'mobx-react';
import {computed, observable} from 'mobx';

import {ClearableInput} from './';

import ASelectInput from './ASelectInput';
import byLogged from "views/plugins/plugin_hr_management/Employees/dialogs/TeamsDialog/Query/List/listAllTeamByLogged";

@observer
class SelectInput extends ASelectInput {

    @observable
    state = {
        lists: {
            list: []
        },
        props: null
    };
    
    constructor(props) {
        super(props);
    }
    
    async componentDidMount() {
        let {className = ''} = this.props;
        className += ` SelectTeamInput`;
        
        const res = await onSelectLoad();
        this.state.lists.list = res.distinct();
        
        this.state.props = {
            ref: "input",
            key: new Date().getTime(),
            name: "team",
            type: "select",
            placeholder: "Team...",
            values: this.list,
            returnValue: true,
            add: false,
            ...this.props,
            defaultValue: this.selectedItem,
            className
        };
    }

    @computed
    get selectedItem() {
        const {defaultValue} = this.props;
        if(defaultValue) {
            if(defaultValue.label && defaultValue.value) {
                return defaultValue;
            }
            let {name, data} = defaultValue;
            const label = data ? data.name : name;
            return {value: defaultValue, label};
        }
        return null;
    }
    
    render() {
        const {props} = this.state;
        if(!props) return null;

        return <ClearableInput {...props}/>;
    }
}

function onSelectLoad() {
    const args = {
        //
        limit: 0,
        offset: 0,
    };
    return byLogged(args).then(res => {
        return res.map(value => {
            const {name, supervisor, site, project, client} = value.data;
            let label = name;
            if(supervisor) {
                const {fname, lname, data} = supervisor;
                label += `-${lname || data.lname} ${fname || data.fname}`;
            }
            return {label, value};
        });
    });
}

export default SelectInput;
